import * as AT from '../actions/_types'

export default (
  prevState = {
    unseenConvoIds: new Set(),
  },
  action,
) => {
  switch (action.type) {
    case AT.FETCH_ALL_UNSEEN_CONVOS: {
      return {
        ...prevState,
        unseenConvoIds: new Set(action.convoIds),
      }
    }
    case AT.ADD_UNSEEN_CONVO: {
      const newSet = new Set(prevState.unseenConvoIds)
      newSet.add(action.convoId)
      return {
        ...prevState,
        unseenConvoIds: newSet,
      }
    }
    case AT.REMOVE_UNSEEN_CONVO: {
      const newSet = new Set(prevState.unseenConvoIds)
      newSet.delete(action.convoId)
      return {
        ...prevState,
        unseenConvoIds: newSet,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/notifications.js